import * as Long from "long";
import { ofType } from "redux-observable";
import { concat, from, of } from "rxjs";
import { mapTo, switchMap, take } from "rxjs/operators";
import { IdDefaultThreshold } from "../../../../constants/IdDefaultThreshold";
import { IdResource } from "../../../../constants/IdResource";
import { selectAndApplyActiveBuildingBuffedCost } from "../../../../selectors/selectBuffsInfo";
import { selectBuildingStageInfo } from "../../../../selectors/selectExistingBuildingInfo";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionOngoingPurchasePremiumSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
import { TypeActionSpendGoldConfirmation } from "../../../spend-gold-confirmation/actionSpendGoldConfirmation";
import { actionBuildingPurchaseConfirmed, TypeActionBuildings, } from "../actionBuildings";
export var epicBuildingPurchaseConfirmationRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.PurchaseConfirmationRequest), switchMap(function (action) {
        if (!action.premium) {
            return of(actionBuildingPurchaseConfirmed(action.building, action.premium));
        }
        var building = action.building;
        var initialStageInfo = selectBuildingStageInfo(building, 0);
        var premiumCost = initialStageInfo.premium.cost.find(function (cost) { return cost.resourceId === IdResource.Gold; });
        var goldAmount = selectAndApplyActiveBuildingBuffedCost(state$.value, action.building.balancing.id, IdResource.Gold, premiumCost.amount);
        if (goldAmount < IdDefaultThreshold.GoldSpendConfirmAmount) {
            return from([
                actionOngoingPurchasePremiumSelect({
                    goldAmount: Long.fromValue(goldAmount),
                    isConfirmed: true,
                }),
                actionBuildingPurchaseConfirmed(action.building, action.premium),
            ]);
        }
        var purchasePremiumInfo = {
            goldAmount: Long.fromValue(goldAmount),
            isConfirmed: false,
        };
        return concat(from([
            actionOngoingPurchasePremiumSelect(purchasePremiumInfo),
            actionModalOpen(IdModal.SpendGoldConfirmation),
        ]), action$.pipe(ofType(TypeActionSpendGoldConfirmation.Finish), take(1), mapTo(actionBuildingPurchaseConfirmed(action.building, action.premium))));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingPurchaseConfirmationRequest.ts
// module id = 2046
// module chunks = 3